import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  NotFound,
  Home,
  Tutor,
  PrivacyPolicy,
  TermsOfUse,
  About,
  Product,
  Signin,
  Signup,
  ClassRoom,
  Lesson,
  Spaces,
  Curriculum,
} from '../pages';

import { webPaths } from './paths';

export default function WebRoute() {
  return (
    <Routes>
      <Route path={webPaths.privacyPolicy} element={<PrivacyPolicy />} />
      <Route path={webPaths.termsOfUse} element={<TermsOfUse />} />
      <Route path={webPaths.root} element={<Home />} />
      <Route path={webPaths.curriculum} element={<Curriculum />} />
      <Route path={`${webPaths.products}/:slug`} element={<Product />} />
      <Route path={`${webPaths.classes}/:slug`} element={<ClassRoom />} />
      <Route path={`${webPaths.lessons}/:slug`} element={<Lesson />} />
      <Route path={webPaths.teach} element={<Tutor />} />
      <Route path={webPaths.about} element={<About />} />
      <Route path={webPaths.signin} element={<Signin />} />
      <Route path={webPaths.signup} element={<Signup />} />
      <Route path={webPaths.teachSignin} element={<Signin />} />
      <Route path={webPaths.teachSignup} element={<Signup />} />
      <Route path={webPaths.spaces} element={<Spaces />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}
